import { useCallback } from 'react';

/**
 * Merges multiple react refs into one usable ref callback.
 */
export function useMergeRefs<E>(...refs: Array<React.Ref<E | null>>): (node: E | null) => void {
  const mergeRefs = useCallback(
    (node: E | null): void => {
      refs.forEach((ref) => {
        if (typeof ref === 'function') ref(node);
        else if (ref !== null && ref !== undefined) {
          const refObject = ref as React.MutableRefObject<E | null>;
          refObject.current = node;
        }
      });
    },
    [refs],
  );

  return mergeRefs;
}
